import { gql } from '@apollo/client';
import {
    ALL_DELIVERY_TIME_INTERVAL_FIELDS_FRAGMENT,
} from 'app/graphql/network/fragments/intervals.fragment';

/**
 * @description
 */
export const LP_GET_FULL_DELIVERY_INTERVALS_DATA = gql`
    query getFullDeliveryIntervalsData ($date: String) {
        deliveryIntervals (date: $date) {
            ...fullDeliveryTimeIntervalsFragment
        }
    }
    ${ALL_DELIVERY_TIME_INTERVAL_FIELDS_FRAGMENT}
`;
